import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_110: DocMigration = {
  maxSchemaVersion: "0.0.110",
  description: "Linked floor heights",
  apply(json: any) {
    if (json.levels) {
      for (let i = 0; i < json.levels.length; i++) {
        delete json.levels[i].floorElevation;
        json.levels[i].sortIndex = i;
      }
    }

    if (json.foundations) {
      for (const foundationId in json.foundations) {
        delete json.foundations[foundationId].perimeter;
      }
    }

    return json;
  },
};

export default migration_0_0_110;
